import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updateDatesFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  updatedBookWidgetFields = {
    ...updatedBookWidgetFields,
    datesField: {
      ...updatedBookWidgetFields.datesField,
      dates: retrieveSearchData.dates.map((dateObject) => {
        return {
          total: 0,
          start: dateObject.departureDate
            ? new Date(dateObject.departureDate)
            : null,
          end: dateObject.returnDate ? new Date(dateObject.returnDate) : null
        };
      })
    }
  };

  return updatedBookWidgetFields;
};
